export default {
  placeholder: 'please enter to search',
};
